// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const nir: CountryValidator<"FR", ParsedPersonId> =
  createValidator("fr.nir", 75);

export default nir;
export const compact = nir.compact;
export const format = nir.format;
export const validate = nir.validate;
export const generate = (): string =>
  nir.generate?.() ??
  (() => {
    throw new Error(
      "Validator fr.nir cannot generate values",
    );
  })();
export const parse = nir.parse;
